import { createRouter, createWebHistory } from 'vue-router'
import { setI18nLanguage, loadLocaleMessages, SUPPORT_LOCALES } from '../i18n'

import type { Router, RouteRecordRaw } from 'vue-router'
import type { I18n, Composer } from 'vue-i18n'

import Login from '../views/Login.vue'
import About from '../views/About.vue'
import SORecom from '../views/SORecom.vue'
import Home from '@/views/Home.vue'
import SORecomDetail from '../views/SORecomDetail.vue'
import Transit from '../views/Transit.vue'
import TransitDetail from '../views/TransitDetail.vue'

export function setupRouter(i18n: I18n): Router {
  const locale: string = i18n.mode === 'legacy' ? i18n.global.locale : ((i18n.global as unknown) as Composer).locale.value
  // setup routes
  const routes: RouteRecordRaw[] = [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/recom',
      name: 'so recom',
      component: SORecom
    },
    {
      path: '/recom/:id',
      name: 'so recom detail',
      component: SORecomDetail
    },
    {
      path: '/transit',
      name: 'Transit',
      component: Transit
    },
    {
      path: '/transit/:id',
      name: 'Transit Detail',
      component: TransitDetail
    },
    // {
    //   path: '/:pathMatch(.*)*',
    //   redirect: () => `/${locale}`
    // }
  ]

  // create router instance
  const router = createRouter({
    history: createWebHistory(),
    routes
  })

  // navigation guards
  router.beforeEach(async to => {
    // const paramsLocale = to.params.locale as string
    const paramsLocale = "en"
    // // use locale if paramsLocale is not in SUPPORT_LOCALES
    // if (!SUPPORT_LOCALES.includes(paramsLocale)) {
    //   return `/${locale}`
    // }

    // // load locale messages
    // if (!i18n.global.availableLocales.includes(paramsLocale)) {
      await loadLocaleMessages(i18n, paramsLocale)
    // }

    // set i18n language
    setI18nLanguage(i18n, paramsLocale)
  })

  return router
}